import { LitElement, html, css } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';
import { showNotification } from '../../LanghoutBetonPortal';

import {
  authenticatedAPICall,
  isSuccessfulAPIResponse,
} from '../../client/api-client';
import {
  formatDate,
  converStatusToReadable,
  converPickOrderStatusToInt,
  PickupOrderStatusManualActionRequired,
  arraysEqual,
  PickupOrderStatusPackageReceiptCreated,
} from '../../util/util';
import { repeat } from 'lit/directives/repeat.js';
import {
  PickupOrder,
  Product,
  PickupSubOrder,
  PickupOrderList,
  PickupOrderInvoice,
  getOrderIDs,
  getCustomerNames,
  getExternalIDs,
  getShippingIDs,
  getShippingCities,
  PickupOrderEmail,
} from '../../types/types';
import '../../elements/dropdown-multiselect-element/dropdown-multiselect-element';
import '../../elements/langhout-button/langhout-button';
import '../../elements/list-nagivation/list-navigation';
import '../../elements/search-dropdown-account/search-dropdown-account';
import '../langhout-beton-view-pickup-order-invoice/langhout-beton-view-pickup-order-invoice';
import { DropdownMultiselectElement } from '../../elements/dropdown-multiselect-element/dropdown-multiselect-element';
import { refreshIcon, sortIcon } from '../../elements/icons/icons';
import {
  addHistory,
  getQueryParamURL,
  getSearchParam,
} from '../../util/list_util';
import { sharedStyles } from '../../elements/shared-styles';
import { SearchDropdownAccount } from '../../elements/search-dropdown-account/search-dropdown-account';

@customElement('langhout-beton-list-finished-orders')
export class LanghoutBetonListFinishedOrders extends LitElement {
  static styles = [
    sharedStyles,
    css`
      .row {
        display: flex;
        flex-direction: row;
      }

      .row-flex {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        flex-flow: row wrap;
      }

      .filter-row {
        min-height: 130px;
      }

      .filter-column {
        margin-bottom: 20px;
      }

      .fat {
        font-weight: 900;
        color: red;
      }

      .label {
        font-weight: bold;
      }

      @media (max-width: 701px) {
        .label {
          text-align: left;
        }
      }

      .product-column {
        text-align: left;
        width: 100%;
        min-width: 120px;
        min-height: calc(54px - 24px);
      }

      .order-id-click {
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: var(--primary-color);
      }

      .order-id-click:hover {
        cursor: pointer;
      }

      .border-bot {
        border-bottom: 2px solid var(--menu-color);
      }

      .column-large {
        text-align: left;
        min-width: calc(350px - 20px);
        max-width: calc(350px - 20px);
      }

      .table-wrapper {
        overflow-x: auto;
      }

      .table-header {
        color: var(--text-color-light);
      }

      .header-column {
        background-color: var(--menu-color);
        padding-left: 12px;
      }

      .column-border-right {
        border-right: 2px solid var(--menu-color);
      }

      .navigation-wrapper {
        margin-top: 20px;
      }

      langhout-beton-view-pickup-order-invoice {
        position: absolute;
        top: 84px;
        right: -200vw;
      }

      :host([backAnimation]) langhout-beton-view-pickup-order-invoice {
        transition-duration: 500ms;
      }

      :host([viewOrder]) langhout-beton-view-pickup-order-invoice {
        transition-duration: 500ms;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: calc(100vw - 60px);
        height: calc(100vh -84px);
        top: 84px;
      }

      langhout-button {
        margin-left: 12px;
      }

      .sort-icon-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .sort-icon {
        transform: rotate(90deg);
      }

      .sort-icon:hover {
        cursor: pointer;
      }

      .sort-active {
        color: var(--text-color-main);
      }

      .order-id-column {
        padding-left: 10px;
        padding-right: 10px;
      }
      .message-icon-wrapper {
        padding-left: 10px;
      }

      #resetButton {
        margin-top: 20px;
      }

      .search-dropdown-account {
        width: 214px;
      }
    `,
  ];

  private requestCounter = 0;

  private listTimer = 0;

  @property({ type: Array })
  private pickupOrders: PickupOrderList = [];

  @property({ type: Number })
  private pickupOrderCount = 0;

  @query('#fromDate')
  public fromDate?: HTMLInputElement;

  @query('#untilDate')
  public untilDate?: HTMLInputElement;

  @query('#orderID')
  public orderID?: HTMLInputElement;

  @query('#shippingID')
  public shippingID?: HTMLInputElement;

  @query('#externalID')
  public externalID?: HTMLInputElement;

  @query('#searchDropdownAccount')
  public searchDropdownAccount?: SearchDropdownAccount;

  @property({ type: Array, attribute: true })
  public selected: Array<string> = [];

  private offset = 0;

  private limit = 50;

  @property({ type: Boolean, reflect: true })
  public viewOrder = false;

  @property({ type: Boolean, reflect: true })
  public backAnimation = false;

  @property({ type: Object })
  private currentViewOrder: PickupOrder = <PickupOrder>{
    sub_orders: <PickupSubOrder[]>[],
  };

  @property({ type: Object, reflect: true })
  private currentInvoiceView: PickupOrderInvoice = <PickupOrderInvoice>{};

  @property({ type: Object, reflect: true })
  private currentEmailView: PickupOrderEmail[] = <PickupOrderEmail[]>[];

  private orderByColumn = '';

  private orderByDirection = '';

  @query('#dropdownElement')
  public dropdownElement?: DropdownMultiselectElement;

  @property({ type: String })
  private lastPath = 'unknown';

  constructor() {
    super();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener(
      'vaadin-router-location-changed',
      this.routerLocationChanged as EventListener,
    );
  }

  protected routerLocationChanged = (): void => {
    this.setPropertiesFromURL();
    this.listWithBackoff(false);
  };

  protected firstUpdated(): void {
    if (this.dropdownElement) {
      this.dropdownElement.selectable = [
        'Afboeken',
        'Pakbon aangemaakt',
        'Pakbon verzonden',
        'Opgeruimd',
        'Handmatige actie vereist',
      ];
    }
    window.addEventListener(
      'vaadin-router-location-changed',
      this.routerLocationChanged as EventListener,
    );
    this.setPropertiesFromURL();
    this.listWithBackoff(false);
  }

  protected setPropertiesFromURL = (): void => {
    const url = getQueryParamURL();
    if (this.orderID) {
      this.orderID.value = getSearchParam(url, 'order_id');
    }
    if (this.shippingID) {
      this.shippingID.value = getSearchParam(url, 'shipping_id');
    }
    if (this.externalID) {
      this.externalID.value = getSearchParam(url, 'external_id');
    }
    if (this.dropdownElement) {
      const stockStatuses = getSearchParam(url, 'states');
      if (stockStatuses !== '') {
        const res: string[] = [];
        const statuses = stockStatuses.split(',');
        statuses.forEach(e => {
          const status = converStatusToReadable(parseInt(e));
          if (!res.includes(status)) {
            res.push(status);
          }
        });
        this.selected = res;
        this.dropdownElement.selected = res;
      } else {
        this.selected = [
          'Afboeken',
          'Pakbon aangemaakt',
          'Handmatige actie vereist',
        ];
        this.dropdownElement.selected = [
          'Afboeken',
          'Pakbon aangemaakt',
          'Handmatige actie vereist',
        ];
      }
    }
    if (this.fromDate) {
      const splittedDate = getSearchParam(url, 'from').split('-');
      if (splittedDate.length === 3) {
        this.fromDate.value = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
      } else {
        this.fromDate.value = '';
      }
    }

    if (this.untilDate) {
      const splittedDate = getSearchParam(url, 'until').split('-');
      if (splittedDate.length === 3) {
        this.untilDate.value = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
      } else {
        this.untilDate.value = '';
      }
    }

    this.orderByColumn = getSearchParam(url, 'order_by');
    this.orderByDirection = getSearchParam(url, 'order_direction');
  };

  render() {
    return html`
      <langhout-beton-view-pickup-order-invoice
        .currentInvoiceView=${this.currentInvoiceView}
        .currentEmailView=${this.currentEmailView}
        @close="${() => {
          this.viewOrder = false;
          this.listWithBackoffWithoutReset();
        }}"
        @reload=${() => {
          this.listWithBackoffWithoutReset();
        }}
      ></langhout-beton-view-pickup-order-invoice>
      ${this.renderFilterRow()}
      <div class="table-wrapper">
        <div class="row table-header">
          <div class="column header-column product-column">
            <div class="row">
              <h3>Order ID</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('order_id')}"
                @click="${() => {
                  this.orderColumns('order_id');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Klant</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('customer_name')}"
                @click="${() => {
                  this.orderColumns('customer_name');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Plaatsnaam</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('shipping_city')}"
                @click="${() => {
                  this.orderColumns('shipping_city');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Vracht ID</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('shipping_id')}"
                @click="${() => {
                  this.orderColumns('shipping_id');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Klant ID</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('external_id')}"
                @click="${() => {
                  this.orderColumns('external_id');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Totaal gewicht</h3>
              <div class="fill"></div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Leverdatum</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('pickup_date')}"
                @click="${() => {
                  this.orderColumns('pickup_date');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Status</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('status')}"
                @click="${() => {
                  this.orderColumns('status');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
        </div>
        ${this.renderRows()}
      </div>
      <div class="navigation-wrapper">
        <list-navigation
          index="${this.offset}"
          limit="${this.limit}"
          total="${this.pickupOrderCount}"
          @change="${(e: CustomEvent) => {
            if (this.offset != e.detail.value) {
              this.offset = parseInt(e.detail.value);
              this.listWithBackoffWithoutReset();
            }
          }}"
        ></list-navigation>
      </div>
    `;
  }

  renderFilterRow = () => {
    return html`
      <div class="row-flex filter-row">
        <div class="column filter-column">
          <div class="label">Order ID</div>
          <div class="input-field">
            <input
              type="text"
              id="orderID"
              name="orderID"
              @input="${() => {
                this.listWithBackoff();
              }}"
            />
          </div>
        </div>
        <div class="column filter-column">
          <div class="label">Vracht ID</div>
          <div class="input-field">
            <input
              type="text"
              id="shippingID"
              name="shippingID"
              @input="${() => {
                this.listWithBackoff();
              }}"
            />
          </div>
        </div>
        <div class="column filter-column">
          <div class="label">Klant ID</div>
          <div class="input-field">
            <input
              type="text"
              id="externalID"
              name="externalID"
              @input="${() => {
                this.listWithBackoff();
              }}"
            />
          </div>
        </div>
        <div class="column filter-column search-dropdown-account">
          <div class="label">Klant</div>
          <div class="input-field">
            <search-dropdown-account
              id="searchDropdownAccount"
              @change="${() => {
                this.listWithBackoff();
              }}"
            ></search-dropdown-account>
          </div>
        </div>
        <div class="column filter-column">
          <div class="label">Status</div>
          <div class="input-field">
            <dropdown-multiselect-element
              id="dropdownElement"
              @change="${(e: CustomEvent) => {
                const newSelected = <Array<string>>JSON.parse(e.detail.value);
                if (!arraysEqual(newSelected, this.selected)) {
                  this.selected = newSelected;
                  this.listWithBackoff();
                }
              }}"
            ></dropdown-multiselect-element>
          </div>
        </div>

        <div class="fill"></div>
      </div>
      <div class="row-flex filter-row">
        <div class="column filter-column">
          <div class="label">Van</div>
          <div class="input-field">
            <input
              type="date"
              id="fromDate"
              name="fromDate"
              @change="${() => {
                this.listWithBackoff();
              }}"
            />
          </div>
        </div>
        <div class="column filter-column">
          <div class="label">Tot</div>
          <div class="input-field">
            <input
              type="date"
              id="untilDate"
              name="untilDate"
              @change="${() => {
                this.listWithBackoff();
              }}"
            />
          </div>
        </div>
        <langhout-button
          text="Reset filters"
          id="resetButton"
          @click="${(): void => {
            window.location.href = '/finished-orders';
          }}"
        ></langhout-button>
        <div class="fill"></div>
        <div
          @click="${() => {
            showNotification('Refreshing Pickup Orders');
            this.listWithBackoff();
          }}"
        >
          ${refreshIcon()}
        </div>
      </div>
    `;
  };

  renderRows = () => {
    return html` ${repeat(
      this.pickupOrders,
      pickupOrder => pickupOrder.id,
      (pickupOrder, index) => {
        let tableColumnClass = 'border-bot';
        if (index == this.pickupOrders.length - 1) {
          tableColumnClass = '';
        }
        return html`
          <div
            class="row table-row"
            @click="${() => {
              this.viewOrder = !this.viewOrder;
              this.backAnimation = true;
              this.currentViewOrder = pickupOrder;
              if (
                this.currentViewOrder.status ==
                PickupOrderStatusPackageReceiptCreated
              ) {
                this.getPickupOrderInvoice();
                this.getEmailPreview();
              } else {
                this.getPickupOrderInvoice();
              }
            }}"
          >
            <div
              class="row order-id-column table-column order-id-click column-border-right product-column ${tableColumnClass}"
            >
              <div>${getOrderIDs(pickupOrder)}</div>
              <div class="fill"></div>
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${getCustomerNames(pickupOrder)}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${getShippingCities(pickupOrder)}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${getShippingIDs(pickupOrder)}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${getExternalIDs(pickupOrder)}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${this.getWeightTotalText(pickupOrder)}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${formatDate(pickupOrder.pickup_date)}
            </div>
            <div class="column table-column product-column ${tableColumnClass}">
              ${this.getStatusHTML(pickupOrder.status)}
            </div>
          </div>
        `;
      },
    )}`;
  };

  getStatusHTML = (status: number) => {
    if (status === PickupOrderStatusManualActionRequired) {
      return html` <div class="fat">${converStatusToReadable(status)}</div> `;
    }
    return html` ${converStatusToReadable(status)} `;
  };

  getWeightTotalText = (pickupOrder: PickupOrder): string => {
    let totalWeight = 0;

    pickupOrder.sub_orders.forEach((subOrder: PickupSubOrder) => {
      subOrder.products.forEach((p: Product) => {
        totalWeight += p.amount * p.weight;
      });
    });
    totalWeight = Math.round(totalWeight);

    return `${totalWeight.toLocaleString('nl-NL')} kg`;
  };

  isSortActive = (column: string): string => {
    if (this.orderByColumn === column) {
      return 'sort-active';
    }
    return '';
  };

  orderColumns = (column: string) => {
    if (this.orderByColumn === column && this.orderByDirection === '') {
      this.orderByDirection = 'asc';
    } else if (
      this.orderByColumn === column &&
      this.orderByDirection === 'asc'
    ) {
      this.orderByColumn = '';
      this.orderByDirection = '';
    } else {
      this.orderByColumn = column;
      this.orderByDirection = '';
    }
    this.listWithBackoff();
  };

  listWithBackoffWithoutReset = () => {
    clearInterval(this.listTimer);
    this.listTimer = window.setTimeout(() => {
      this.listPickupOrders();
    }, 50);
  };

  listWithBackoff = (recordHistory: boolean = true) => {
    clearInterval(this.listTimer);
    this.listTimer = window.setTimeout(() => {
      this.offset = 0;
      this.listPickupOrders(recordHistory);
    }, 50);
  };

  createFilterArray = (): string[] => {
    const filterArray: string[] = [];
    const statusFilterIntegerArray: Array<number> = [];
    this.selected.forEach(element => {
      statusFilterIntegerArray.push(...converPickOrderStatusToInt(element));
    });
    if (statusFilterIntegerArray.length == 0) {
      return [];
    }
    filterArray.push(`states=${statusFilterIntegerArray.join(',')}`);

    const fromDate = this.fromDate ? this.fromDate.value : '';
    if (fromDate != '') {
      filterArray.push(`from=${formatDate(fromDate)}`);
    }

    const accountCode = this.searchDropdownAccount
      ? this.searchDropdownAccount.selected?.code || ''
      : '';
    if (accountCode != '') {
      filterArray.push(`customer_code=${accountCode}`);
    }

    const untilDate = this.untilDate ? this.untilDate.value : '';
    if (untilDate != '') {
      filterArray.push(`until=${formatDate(untilDate)}`);
    }

    const orderID = this.orderID ? this.orderID.value : '';
    if (orderID != '') {
      filterArray.push(`order_id=${orderID}`);
    }

    const shippingID = this.shippingID ? this.shippingID.value : '';
    if (shippingID != '') {
      filterArray.push(`shipping_id=${shippingID}`);
    }

    const externalID = this.externalID ? this.externalID.value : '';
    if (externalID != '') {
      filterArray.push(`external_id=${externalID}`);
    }
    filterArray.push(`order_by=${this.orderByColumn}`);
    filterArray.push(`order_direction=${this.orderByDirection}`);
    return filterArray;
  };

  listPickupOrders = async (recordHistory: boolean = true) => {
    this.requestCounter++;
    const requestCounter = this.requestCounter;
    const filterArray = this.createFilterArray();
    if (filterArray.length === 0) {
      return;
    }

    let path = `/pickuporders?limit=${this.limit}&offset=${this.offset}`;
    const filter = filterArray.join('&');
    if (filter !== '') {
      if (recordHistory) {
        addHistory(filter);
      }
      path += '&' + filter;
    }

    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (!isSuccessfulAPIResponse(result)) {
      return;
    }
    if (requestCounter != this.requestCounter) {
      return;
    }
    const xCount = result.headers.get('x-count');
    if (xCount) {
      this.pickupOrderCount = parseInt(xCount);
    }

    this.pickupOrders = result.body;
    // If we have a selected view order overwrite.
    if (this.currentViewOrder.id != '') {
      this.pickupOrders.forEach((order: PickupOrder) => {
        if (this.currentViewOrder.id === order.id) {
          this.currentViewOrder = order;
        }
      });
    }
    if (
      this.currentInvoiceView &&
      this.currentInvoiceView.id &&
      this.currentInvoiceView.id != ''
    ) {
      this.getPickupOrderInvoice();
    }
  };

  getPickupOrderInvoice = async () => {
    const path = `/pickuporders/${this.currentViewOrder.id}/invoice`;
    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (isSuccessfulAPIResponse(result)) {
      this.currentInvoiceView = result.body;
    }
  };

  getEmailPreview = async () => {
    const path = `/emails/${this.currentViewOrder.id}`;
    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (isSuccessfulAPIResponse(result)) {
      this.currentEmailView = result.body;
    }
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-list-finished-orders': LanghoutBetonListFinishedOrders;
  }
}
